import { render, staticRenderFns } from "./LeadStopReason.vue?vue&type=template&id=2f78c9a6&scoped=true"
import script from "./LeadStopReason.vue?vue&type=script&lang=js"
export * from "./LeadStopReason.vue?vue&type=script&lang=js"
import style0 from "./LeadStopReason.vue?vue&type=style&index=0&id=2f78c9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78c9a6",
  null
  
)

export default component.exports